import { navLinks } from "@/mocks/home";

const serviceLinks = [
  { id: "report", label: "投稿爆料" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];

export default function Footer() {
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <footer className="bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl font-bold tracking-tight text-background-50">
                吃瓜<span className="text-secondary-300">17</span>
              </span>
            </button>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-primary-200/80">
              聚焦热点焦点排行，实时盘点热议大瓜与焦点话题。聚合公开信息、还原来龙去脉，理性围观不迷路，把热闹看明白，也把清醒留给自己。
            </p>
            <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-primary-500/20 px-3 py-1.5 text-xs font-bold text-primary-100">
              <i className="ri-mail-line text-secondary-300"></i>
              hello@chiagua17.readdy.site
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-base font-bold text-background-50">栏目导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-200/80">
              {navLinks.map((n) => (
                <li key={n.id}>
                  <button type="button" onClick={() => go(n.id)} className="flex items-center gap-2 transition-colors hover:text-background-50">
                    <i className="ri-arrow-right-s-line text-secondary-300"></i>
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-base font-bold text-background-50">更多服务</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-200/80">
              {serviceLinks.map((n) => (
                <li key={n.id}>
                  <button type="button" onClick={() => go(n.id)} className="flex items-center gap-2 transition-colors hover:text-background-50">
                    <i className="ri-arrow-right-s-line text-secondary-300"></i>
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-base font-bold text-background-50">内容原则</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-200/80">
              <li className="flex items-center gap-2"><i className="ri-check-line text-accent-300"></i>真实可查证</li>
              <li className="flex items-center gap-2"><i className="ri-check-line text-accent-300"></i>尊重隐私</li>
              <li className="flex items-center gap-2"><i className="ri-check-line text-accent-300"></i>立场中立</li>
              <li className="flex items-center gap-2"><i className="ri-check-line text-accent-300"></i>实时更新</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-500/30">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-200/70 md:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 吃瓜17 · 资讯聚合平台 · 理性围观，把结论交给时间</p>
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-1.5 transition-colors hover:text-background-50">
            回到顶部
            <i className="ri-arrow-up-line"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}